
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audio-to-text",
      function () {
        return require("private-next-pages/audio-to-text/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audio-to-text"])
      });
    }
  